import { Box, Card, CardContent, CardHeader, Grid, IconButton, Stack, Tooltip, Typography } from "@mui/material"
import ReduceCapacityIcon from '@mui/icons-material/ReduceCapacity';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';

const MuiDashboardEmployment = () => {
    return (

        <Card sx={{ height: 300 }}>
            <CardHeader
                subheader="İstihdam"
                avatar={<ReduceCapacityIcon />}
                action={
                    <Tooltip title="Detay göster">
                        <IconButton>
                            <MoreHorizIcon />
                        </IconButton>
                    </Tooltip>
                }
            />
            <CardContent>
                {/* <Stack >
                    <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
                        <Typography>İşe giren sayısı </Typography>
                        <Typography variant="h3" color="red" > 12 </Typography>
                    </Stack>
                    <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
                        <Typography>İşten ayrılan sayısı </Typography>
                        <Typography variant="h3">5 </Typography>
                    </Stack>
                    <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
                        <Typography>Açık pozisyonlar </Typography>
                        <Typography variant="h3">Yok</Typography>
                    </Stack>

                </Stack> */}
                <Stack spacing={2} >
                    {/* <Typography>İstihdam</Typography> */}
                    <Stack direction="row" spacing={4} justifyContent="space-between">
                        <Stack direction="row" spacing={2}>
                            <PersonAddIcon />
                            <Typography>İşe giren sayısı </Typography>
                        </Stack>
                        <Typography variant="h3">5</Typography>
                    </Stack>
                    <Stack direction="row" spacing={4} justifyContent="space-between" >
                        <Stack direction="row" spacing={2}>
                            <PersonRemoveIcon />
                            <Typography>İşten ayrılan sayısı </Typography>
                        </Stack>
                        <Typography variant="h3">3</Typography>
                    </Stack>
                    <Stack direction="row" spacing={4} justifyContent="space-between">
                        <Stack direction="row" spacing={2}>
                            <PersonSearchIcon />
                            <Typography>Açık pozisyonlar </Typography>
                        </Stack>
                        <Typography variant="h3">0</Typography>
                    </Stack>
                    <Stack direction="row" spacing={4} justifyContent="space-between">
                        <Stack direction="row" spacing={2}>
                            <PersonSearchIcon />
                            <Typography>Başvurular </Typography>
                        </Stack>
                        <Typography variant="h3">0</Typography>
                    </Stack>
                </Stack>

            </CardContent>

        </Card>

    )
}

export default MuiDashboardEmployment;